import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/images/logo_fk.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowNavbar(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    setIsMenuOpen(false);

    // Si on est sur la page d'accueil
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Si on est sur une autre page, naviguer vers l'accueil puis scroller
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        showNavbar ? "bg-black shadow-lg" : "bg-black"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img
                src={logo}
                alt="FlowKraft Agency"
                className="h-12 w-auto cursor-pointer"
              />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#services"
              onClick={(e) => handleNavClick(e, "services")}
              className="text-white hover:text-flowkraft-secondary transition-colors cursor-pointer"
            >
              Services
            </a>
            <a
              href="#process"
              onClick={(e) => handleNavClick(e, "process")}
              className="text-white hover:text-flowkraft-secondary transition-colors cursor-pointer"
            >
              Méthodologie
            </a>
            <a
              href="#portfolio"
              onClick={(e) => handleNavClick(e, "portfolio")}
              className="text-white hover:text-flowkraft-secondary transition-colors cursor-pointer"
            >
              Portfolio
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleNavClick(e, "testimonials")}
              className="text-white hover:text-flowkraft-secondary transition-colors cursor-pointer"
            >
              Témoignages
            </a>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, "contact")}
              className="bg-flowkraft-primary hover:bg-flowkraft-secondary text-white px-6 py-2 rounded-lg transition-all duration-300 cursor-pointer"
            >
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-black py-4">
            <a
              href="#services"
              onClick={(e) => handleNavClick(e, "services")}
              className="block text-white hover:text-flowkraft-secondary py-2 px-4 transition-colors cursor-pointer"
            >
              Services
            </a>
            <a
              href="#process"
              onClick={(e) => handleNavClick(e, "process")}
              className="block text-white hover:text-flowkraft-secondary py-2 px-4 transition-colors cursor-pointer"
            >
              Méthodologie
            </a>
            <a
              href="#portfolio"
              onClick={(e) => handleNavClick(e, "portfolio")}
              className="block text-white hover:text-flowkraft-secondary py-2 px-4 transition-colors cursor-pointer"
            >
              Portfolio
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleNavClick(e, "testimonials")}
              className="block text-white hover:text-flowkraft-secondary py-2 px-4 transition-colors cursor-pointer"
            >
              Témoignages
            </a>
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, "contact")}
              className="block text-white hover:text-flowkraft-secondary py-2 px-4 transition-colors cursor-pointer"
            >
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
